import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initializeGoogleTags } from '@/utils/googleAnalytics'

// Consent Mode v2: define o consentimento padrão (negado) antes de qualquer tag carregar.
initializeGoogleTags()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)